export default [
  /*** 用户 开始 ***/
  {
    path: '/member/list',
    component: () => import('../pages/member/member/index.vue'),
    meta: {title: '用户管理'}
  },
  {
    path: '/member/edit/:memberId',
    component: () => import('../pages/member/member/edit.vue'),
    meta: {title: '用户编辑'}
  },
  {
    path: '/member/create',
    component: () => import('../pages/member/member/create.vue'),
    meta: {title: '用户创建'}
  },
  {
    path: '/member/category',
    component: () => import('../pages/member/member/category.vue'),
    meta: {title: '用户分组管理'}
  },
  /*** 用户 结束 ***/

  /*** 提现管理 开始 ***/
  {
    path: '/member/withdraw',
    component: () => import('../pages/member/withdraw/index.vue'),
    meta: {title: '提现管理'}
  },
  /*** 提现管理 结束 ***/

  /*** 用户费率 开始 ***/
  {
    path: '/member/charge',
    component: () => import('../pages/member/charge/index.vue'),
    meta: {title: '用户费率'}
  },
  /*** 用户费率 结束 ***/

  /*** 消息推送 开始 ***/
  {
    path: '/member/notice',
    component: () => import('../pages/member/notice/list.vue'),
    meta: {title: '消息推送'}
  },
  {
    path: '/member/notice/category',
    component: () => import('../pages/member/notice/category.vue'),
    meta: {title: '消息分类'}
  },
  {
    path: '/member/notice/:noticeId',
    component: () => import('../pages/member/notice/push.vue'),
    meta: {title: '消息推送'}
  },
  /*** 消息推送 结束 ***/
]
